/* eslint-disable no-console */

if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${import.meta.env.BASE_URL}service-worker.js`)
      .then((registration) => {
        console.log('Service worker registered.', registration);

        registration.addEventListener('updatefound', () => {
          console.log('New content is downloading.');
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                console.log('New content is available; please refresh.');
                newWorker.postMessage({ action: 'skipWaiting' });
              }
            });
          }
        });
      })
      .catch((error) => {
        console.error('Error during service worker registration:', error);
      });
  });
}
